import { get } from 'lodash';
import { CREATE_SUCCESS, CREATE_REQUEST } from 'store/modules/bookings';
import { TrackingClient } from '@sparefoot/tracking-client';

const bookingsMiddleware = (store) => (next) => (action) => {
	if (action.type === CREATE_REQUEST) {
		const { units, user } = store.getState();

		let data = action?.data;

		let unit = units?.byId[data.unitId];

		TrackingClient.trackReservationStarted({
			cart_products_count: 1,
			cart_value: unit?.price?.sparefoot,
			currency: 'usd',
			products: data.unitId,
			unit: {
				currency: 'usd',
				id: data.unitId,
				variant_size: unit?.sizeText,
				price: unit?.price?.sparefoot,
				quantity: 1,
			},
			unit_id: data.unitId,
			unit_promo: unit?.promotion,
			traffic_source_id: user?.traffic_source_id,
			cid: user?.cid,
			ctid: user?.ctid,
		});
	}
	if (action.type === CREATE_SUCCESS) {
		const { user } = store.getState();
		const confirmationCode = action.payload?.result;

		const booking = get(
			action,
			`payload.entities.bookings[${confirmationCode}]`,
		);

		try {
			TrackingClient.trackReservationCompleted({
				unit: {
					currency: 'usd',
					id: booking.unitId,
					variant_size: booking.bookedUnit.size,
					price: booking.bookedUnit.price.meta,
					quantity: 1,
				},
				reservation_confirmation: booking.confirmationCode,
				unit_id: booking.unitId,
				email: booking.email,
				first_name: booking.firstName,
				last_name: booking.lastName,
				first_order_date: Date.now(),
				last_order_date: Date.now(),
				move_in_date: booking.moveIn,
				promotion_code: booking.promoCode,
				unit_promo: booking.bookedUnit.promotion,
				phone: booking.phone,
				revenue: booking.estimatedRevenue,
				tax: '',
				discounts: '',
				currency: 'USD',
				traffic_source_id: user?.traffic_source_id,
				cid: user?.cid,
				ctid: user?.ctid,
			});
		} catch (err) {
			console.log({ err }, 'UNABLE TO TRACK BOOKING SUCCESS');
		}
	}

	return next(action);
};

export default bookingsMiddleware;
